module.exports = __webpack_public_path__ + "img/b1-4-6.09cf6bd4.jpg";